import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { castDraft } from "immer";
import { defaultRootState } from "./default-root-state";

const pasteboardStateSlice = createSlice({
    name: "globalPasteboard",
    initialState: defaultRootState.pasteboard,
    reducers: {
        setPasteboard: (state, action: PayloadAction<typeof defaultRootState.pasteboard>) => {
            state.components = castDraft(Array.from(action.payload.components));
        },
    },
});

export const { setPasteboard } = pasteboardStateSlice.actions;
export default pasteboardStateSlice.reducer;
